import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/auth/auth.service';

@Component({
    selector: 'cml-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  
  constructor(private router: Router, private authService: AuthService) { }

  ngOnInit(): void {
  }

  navigateHome() {
    this.router.navigate(['']);
  }

  logout() {
    this.authService.logout();
  }

  login() {
    this.authService.login();
  }
}
